<script setup lang="ts">
import type { GlobalConfig } from '@/types/configuration';

import { useGlobalConfigurationStore } from '@/stores/useGlobalConfigurationStore';

const props = defineProps<{
  config: GlobalConfig | string;
}>();

if (!props.config) {
  throw new Error('Missing settings for youbook initialization');
}

const parsedConfig: GlobalConfig = typeof props.config === 'string'
  ? JSON.parse(props.config)
  : props.config || {};

if (!['fr-FR', 'en-GB', 'en-US', 'de-DE', 'es-ES', 'it-IT', 'zh-CN', 'fr', 'en', 'de', 'es', 'it', 'zh'].includes(parsedConfig.locale)) {
  throw new Error('Invalid locale provided');
}

const configurationStore = useGlobalConfigurationStore();
configurationStore.setGlobalConfiguration(parsedConfig);
configurationStore.setCurrentLocale(parsedConfig.locale);
</script>
